import URI from "urijs";
import { getLocaleFromUrl } from "./locale.utils";
const krampPrefix = "https://www.kramp.com";
export const ciPrefix = `${krampPrefix}/shop`;

const basePath = () => {
  const { region, language } = getLocaleFromUrl();
  return `${ciPrefix}-${region}/${language}`;
};

export const stripProtocol = href => href.replace(/(^\w+:|^)\/\//, "");

// page links
export const cmsLink = path => `${basePath()}/i/${path}`;
export const SIZE_CONFIGURATIONS = {
  DIRECT: "direct", // original image size
  SMALL_THUMB: "small_thumb", // 50X50
  THUMB: "thumb", // 100X100
  REDESIGNCAT: "redesigncat", // 150X150
  KRAMPS: "kramps", // 300X300, kramp watermark
  KRAMPD_RD: "krampd_rd", // 600X600, kramp watermark
  DEUTZS: "deutzs", // 300X300, deutzfahr watermark
  DEUTZD_RD: "deutzd_rd", // 600X600, deutzfahr watermark
  BL070: "bl070", // brandimage 70x70
  BL100: "bl100", // brandimage 100X100
  BL150: "bl150" // brandimage 150X150
};

/* mediaserver possibilities: {domain}/kws/{size}/{usage}%2F{filename}

  usage:
  brandlogos = brands
  standard = catalog images (categories, productgroups, products)

  size:
  direct = original image
  small_thumb = 50X50
  thumb = 100X100
  redesigncat = 150X150
  kramps = 300X300, kramp watermark
  krampd_rd = 600X600, kramp watermark
  deutzs = 300X300, deutzfahr watermark
  deutzd_rd = 600X600, deutzfahr watermark
  bl070 = brandimage 70x70
  bl100 = brandimage 100X100
  bl150 = brandimage 150X150
 */

export const isInternalLink = (() => {
  // FIXME: When navigating to a different locale, we should reload. (milestone 6)

  const localePatterns = {
    atDe: ["shop-at/de"],
    beFr: ["shop-be/fr"],
    beNl: ["shop-be/nl"],
    deDe: ["shop-de/de"],
    enGb: ["shop-gb/en"],
    esEs: ["shop-es/es"],
    itIt: ["shop-it/it"]
  };

  const validHrefPatterns = [
    "^/%LOCALE%/i/",
    "^/%LOCALE%/an/",
    "^/%LOCALE%/n/"
  ];

  const localePat = /%LOCALE%/g;

  const internalLinkPatterns: any = [];
  validHrefPatterns.forEach(patternStr => {
    if (localePat.exec(patternStr)) {
      Object.keys(localePatterns).forEach(key => {
        localePatterns[key].forEach(locale => {
          internalLinkPatterns.push(
            new RegExp(patternStr.replace(localePat, locale))
          );
        });
      });
    } else {
      internalLinkPatterns.push(new RegExp(patternStr));
    }
  });

  return href => {
    if (!href) return false;

    const uri = URI(href);
    const origin = uri.origin();
    const current = URI(window.location);

    if (origin !== "" && origin !== current.origin()) return false;
    //@ts-ignore
    return (
      internalLinkPatterns.findIndex(pattern =>
        pattern.exec(uri.pathname())
      ) !== -1
    );
  };
})();
